module.exports = __webpack_public_path__ + "img/expert.7886b132.png";